// Connector incidents (admin-portal) — the platform-wide connector-health view from
// migration-service: degraded connections (status=error) or ones with failed sync runs
// in the last 7 days, across all tenants. Reached through the gateway at
// /api/v1/integrations/admin/incidents (platform-role-guarded server-side).
import axios from 'axios';

const API_V1 = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(
  /\/api(\/v1)?\/?$/,
  '/api/v1',
);

export interface ConnectorIncident {
  tenant_id: string;
  connection_id: string;
  name: string;
  connector_key: string;
  status: string; // 'error' | 'active' | ...
  last_error?: string;
  last_sync_at?: string;
  failed_runs_7d: number;
}

export const getConnectorIncidents = () =>
  axios
    .get<{ incidents: ConnectorIncident[] }>(`${API_V1}/integrations/admin/incidents`)
    .then((r) => r.data.incidents ?? []);
